<div class="mention-input-container">
  <textarea
    #textarea
    class="form-control mention-textarea"
    [placeholder]="placeholder"
    [rows]="rows"
    [value]="content"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
    (blur)="onBlur()"
  ></textarea>

  <div
    #dropdown
    class="mention-dropdown"
    *ngIf="showDropdown"
    [style.top.px]="dropdownPosition.top"
    [style.left.px]="dropdownPosition.left"
  >
    <div class="mention-dropdown-content">
      <div *ngIf="isLoading" class="mention-loading">
        <i class="fa-spin fas fa-spinner"></i>
        <span>Searching...</span>
      </div>

      <ng-container *ngIf="!isLoading">
        <div
          *ngIf="suggestions.length === 0"
          class="mention-no-results"
        >
          No staff members found
        </div>

        <div
          *ngFor="let staff of suggestions; let i = index"
          class="mention-item"
          [class.selected]="i === selectedIndex"
          (mousedown)="selectSuggestion(staff)"
          (mouseenter)="selectedIndex = i"
        >
          <div class="mention-item-avatar">
            <img
              *ngIf="staff.avatar"
              [src]="staff.avatar"
              [alt]="staff.first_name"
            />
            <span *ngIf="!staff.avatar" class="avatar-placeholder">
              {{ staff.first_name.charAt(0) }}{{ staff.last_name.charAt(0) }}
            </span>
          </div>
          <div class="mention-item-info">
            <div class="mention-item-name">
              {{ staff.first_name }} {{ staff.last_name }}
            </div>
            <div class="mention-item-email">{{ staff.email }}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="mention-hint" *ngIf="!showDropdown">
    <small>Type @ to mention a staff member</small>
  </div>
</div>

